/* Profit AI social stories (product page section).
 *
 * Port of the Profit AI Video Stories player. Each product page gets only its
 * own videos (Liquid picks them), plus creator videos tagged to the product in
 * Profit AI when the feed is on. The player's add to cart button runs this
 * page's real add to cart button, so the selected pack, quantity and purchase
 * option are what goes to the cart.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pickSource(sources) {
    if (!sources || !sources.length) return '';
    var best = null;
    sources.forEach(function (s) {
      if (!s || !s.url) return;
      var h = s.height || 0;
      if (h > 1080) return;
      if (!best || h > (best.height || 0)) best = s;
    });
    return (best || sources[0]).url;
  }

  function findRealButton(cfg) {
    var forms = document.querySelectorAll('product-form form[data-type="add-to-cart-form"]');
    for (var i = 0; i < forms.length; i++) {
      if (String(forms[i].getAttribute('data-product-id')) !== String(cfg.productId)) continue;
      var btn = forms[i].querySelector('.pdp-qty-btns .pdp-btn .submit_btn') || forms[i].querySelector('.submit_btn');
      if (btn) return btn;
    }
    // Everyday Mints template: its own buy box form (one per page, no product id attribute).
    var mintForm = document.querySelector('form[data-mint-product-form]');
    if (mintForm) return mintForm.querySelector('[data-add-to-cart]');
    return null;
  }

  function realUsable(btn) {
    return !!btn && !btn.classList.contains('d-none') && !btn.disabled && !btn.hasAttribute('disabled');
  }

  function init(section, cfg) {
    var stories = (cfg.stories || []).slice();
    var scrollEl = section.querySelector('[data-pss-scroll]');
    var navPrev = section.querySelector('.pss__nav--prev');
    var navNext = section.querySelector('.pss__nav--next');
    var overlay = section.querySelector('.pss__overlay');
    var video = overlay.querySelector('.pss__feed-video');
    var playBtn = overlay.querySelector('.pss__feed-play');
    var closeBtn = overlay.querySelector('.pss__feed-close');
    var progressFill = overlay.querySelector('.pss__feed-progress-fill');
    var muteBtn = overlay.querySelector('[data-action="mute"]');
    var priceEl = overlay.querySelector('[data-pss-product-price]');
    var variantEl = overlay.querySelector('[data-pss-product-variant]');
    var imgEl = overlay.querySelector('[data-pss-product-img]');
    var addBtn = overlay.querySelector('[data-pss-add]');
    var currentIndex = 0;
    var isMuted = true;
    var progressTimer = null;
    var lastFocus = null;

    // Overlay must sit above the theme's headers and drawers. A product switch
    // or editor reload re-renders the section, so drop the old copy first.
    document.querySelectorAll('body > .pss__overlay').forEach(function (old) {
      if (old !== overlay && old.id === overlay.id) old.remove();
    });
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

    function updateNav() {
      if (!scrollEl) return;
      var start = scrollEl.scrollLeft <= 10;
      var end = scrollEl.scrollLeft >= scrollEl.scrollWidth - scrollEl.clientWidth - 10;
      if (navPrev) navPrev.classList.toggle('pss--hidden', start);
      if (navNext) navNext.classList.toggle('pss--hidden', end);
    }

    function watchPreviews() {
      if (reduceMotion) return;
      var previews = section.querySelectorAll('[data-pss-preview]:not([data-pss-watched])');
      if (!previews.length) return;
      var tryPlay = function (v) {
        if (v.preload === 'none') v.preload = 'metadata';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (!('IntersectionObserver' in window)) {
        previews.forEach(tryPlay);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) tryPlay(entry.target);
          else entry.target.pause();
        });
      }, { threshold: 0.3 });
      previews.forEach(function (v) {
        v.setAttribute('data-pss-watched', '1');
        io.observe(v);
      });
    }

    function bindStory(el) {
      if (el.getAttribute('data-pss-bound')) return;
      el.setAttribute('data-pss-bound', '1');
      el.addEventListener('click', function () { openPlayer(parseInt(el.getAttribute('data-index'), 10)); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPlayer(parseInt(el.getAttribute('data-index'), 10));
        }
      });
    }

    function syncProductCard() {
      var real = findRealButton(cfg);
      var row = real && (real.closest('.pdp-qty-btns') || real.closest('form'));
      var livePrice = row && row.querySelector('[data-sticky-price], [data-add-to-cart-price]');
      if (priceEl) priceEl.textContent = (livePrice && livePrice.textContent.trim()) || cfg.price || '';
      var mintHost = real && real.closest('mint-main-product');
      var current = (mintHost && mintHost.currentVariant) ||
        (window.globalVariables && window.globalVariables.product && window.globalVariables.product.currentVariant);
      if (current && String(current.product_id || cfg.productId) === String(cfg.productId)) {
        if (variantEl && current.title) variantEl.textContent = current.title;
        var src = (current.featured_image && current.featured_image.src) ||
          (current.featured_media && current.featured_media.preview_image && current.featured_media.preview_image.src);
        if (imgEl && src) imgEl.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=150';
      }
      var usable = realUsable(real);
      addBtn.disabled = !usable;
      if (usable) {
        addBtn.textContent = cfg.addLabel || 'Add to cart';
      } else {
        var label = real && real.closest('.pdp-btn') && real.closest('.pdp-btn').querySelector('.dummy_btn:not(.d-none) .add-text');
        addBtn.textContent = (label && label.textContent.trim()) || cfg.soldOutLabel || 'Sold out';
      }
    }

    function startProgress() {
      clearInterval(progressTimer);
      progressFill.style.width = '0%';
      progressTimer = setInterval(function () {
        if (video.duration) progressFill.style.width = (video.currentTime / video.duration) * 100 + '%';
      }, 100);
    }

    function loadStory(index) {
      var story = stories[index];
      if (!story) return;
      video.pause();
      clearInterval(progressTimer);
      progressFill.style.width = '0%';
      if (story.poster) video.setAttribute('poster', story.poster);
      else video.removeAttribute('poster');
      video.src = pickSource(story.sources);
      video.muted = isMuted;
      var onReady = function () {
        video.removeEventListener('canplay', onReady);
        var p = video.play();
        if (p && p.then) {
          p.then(function () { playBtn.classList.add('pss--hidden'); })
            .catch(function () { playBtn.classList.remove('pss--hidden'); });
        }
      };
      video.addEventListener('canplay', onReady);
      video.load();
      startProgress();
      var els = section.querySelectorAll('.pss__story');
      if (els[index]) els[index].classList.add('pss--viewed');
    }

    function openPlayer(index) {
      if (!stories[index]) return;
      currentIndex = index;
      lastFocus = document.activeElement;
      syncProductCard();
      overlay.classList.add('pss--active');
      if (window.innerWidth < 769) document.documentElement.style.overflow = 'hidden';
      loadStory(index);
      closeBtn.focus({ preventScroll: true });
    }

    function closePlayer() {
      if (!overlay.classList.contains('pss--active')) return;
      overlay.classList.remove('pss--active');
      document.documentElement.style.overflow = '';
      video.pause();
      video.removeAttribute('src');
      video.load();
      clearInterval(progressTimer);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function navigate(dir) {
      var next = currentIndex + dir;
      if (next < 0 || next >= stories.length) return;
      currentIndex = next;
      loadStory(currentIndex);
    }

    video.addEventListener('ended', function () {
      if (currentIndex < stories.length - 1) navigate(1);
      else closePlayer();
    });

    video.addEventListener('click', function (e) {
      e.stopPropagation();
      if (video.paused) {
        video.play().then(function () { playBtn.classList.add('pss--hidden'); }).catch(function () {});
      } else {
        video.pause();
        playBtn.classList.remove('pss--hidden');
      }
    });

    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.play().then(function () { playBtn.classList.add('pss--hidden'); }).catch(function () {});
    });

    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      closePlayer();
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePlayer();
    });

    overlay.querySelectorAll('[data-action]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var action = btn.getAttribute('data-action');
        if (action === 'mute') {
          isMuted = !isMuted;
          video.muted = isMuted;
          overlay.classList.toggle('pss--sound', !isMuted);
          muteBtn.setAttribute('aria-label', isMuted ? 'Turn sound on' : 'Turn sound off');
        } else if (action === 'prev') {
          navigate(-1);
        } else if (action === 'next') {
          navigate(1);
        }
      });
    });

    // Add to cart runs the product page's own button: same variant, quantity,
    // purchase option and cart drawer as the main form.
    addBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var real = findRealButton(cfg);
      if (!realUsable(real)) {
        syncProductCard();
        return;
      }
      closePlayer();
      real.click();
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('pss--active')) return;
      if (e.key === 'Escape') closePlayer();
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
    });

    (function () {
      var startY = 0;
      var wrap = overlay.querySelector('.pss__feed-video-wrap');
      wrap.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        var dy = startY - e.changedTouches[0].clientY;
        if (Math.abs(dy) > 50) navigate(dy > 0 ? 1 : -1);
      }, { passive: true });
    })();

    if (navPrev) navPrev.addEventListener('click', function () { scrollEl.scrollBy({ left: -300, behavior: 'smooth' }); });
    if (navNext) navNext.addEventListener('click', function () { scrollEl.scrollBy({ left: 300, behavior: 'smooth' }); });
    if (scrollEl) scrollEl.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);

    section.querySelectorAll('.pss__story').forEach(bindStory);
    watchPreviews();
    setTimeout(updateNav, 100);

    // Creator videos curated in Profit AI and tagged to this product.
    if (cfg.feed && cfg.feed.origin && cfg.feed.shop && window.fetch) {
      var feedUrl = cfg.feed.origin.replace(/\/+$/, '') + '/api/shoppable-feed?shop=' + encodeURIComponent(cfg.feed.shop);
      fetch(feedUrl, { credentials: 'omit' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (feed) {
          if (!feed || !feed.videos || !feed.videos.length) return;
          var handle = String(cfg.productHandle || '').toLowerCase();
          var max = cfg.maxStories || 24;
          feed.videos.forEach(function (item) {
            if (stories.length >= max || !item || !item.mediaUrl) return;
            var tagged = (item.products || []).some(function (p) {
              return p && String(p.handle || '').toLowerCase() === handle;
            });
            if (!tagged) return;
            var title = item.creatorName || (item.authorHandle ? '@' + item.authorHandle : '');
            stories.push({ title: title, poster: item.thumbnailUrl || '', sources: [{ url: item.mediaUrl, height: 0 }] });
            scrollEl.appendChild(buildCircle(stories.length - 1, title, item.thumbnailUrl, item.mediaUrl));
          });
          if (stories.length) section.hidden = false;
          section.querySelectorAll('.pss__story').forEach(bindStory);
          watchPreviews();
          updateNav();
        })
        .catch(function () {});
    }

    function buildCircle(index, title, poster, src) {
      var el = document.createElement('div');
      el.className = 'pss__story';
      el.setAttribute('data-index', String(index));
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Play ' + (title || 'video story'));
      var ring = document.createElement('div');
      ring.className = 'pss__ring';
      var thumb = document.createElement('div');
      thumb.className = 'pss__thumb';
      if (poster) {
        var img = document.createElement('img');
        img.src = poster;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      } else {
        var v = document.createElement('video');
        v.className = 'pss__story-video';
        v.src = src + '#t=0.1';
        v.muted = true;
        v.playsInline = true;
        v.preload = 'metadata';
        v.setAttribute('aria-hidden', 'true');
        thumb.appendChild(v);
      }
      ring.appendChild(thumb);
      el.appendChild(ring);
      if (title && section.querySelector('.pss__story-title')) {
        var t = document.createElement('span');
        t.className = 'pss__story-title';
        t.textContent = title;
        el.appendChild(t);
      }
      return el;
    }
  }

  function boot() {
    document.querySelectorAll('script[data-pss-config]:not([data-pss-booted])').forEach(function (node) {
      node.setAttribute('data-pss-booted', '1');
      try {
        var cfg = JSON.parse(node.textContent);
        var section = document.getElementById('pss-' + cfg.sectionId);
        if (section) init(section, cfg);
      } catch (err) {
        if (window.console) console.warn('[profit-social-stories] bad config', err);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('productSwitched', boot);
  document.addEventListener('shopify:section:load', boot);
})();
